<div #pivotContainer class="container pivot-container">
    <div class="col-12 col-md-4 my-4 d-flex justify-content-between align-items-center w-100">
        <div class="col-7 row">
            <div class="col-3">
                <div class="d-flex gap-2 align-items-center">
                    <select class="form-control form-select col-12" [(ngModel)]="selectedPartnerId" (ngModelChange)="onPartnerChange($event)">
                        <option value="0">
                            {{ 'common.please_select' | translate }}
                        </option>
                        <option *ngFor="let partner of partnerList" [value]="partner.id">
                            {{ partner.name }}
                        </option>
                    </select>
                    <i *ngIf="selectedPartnerId && selectedPartnerId != 0" class="fas fa-times clear-icon" (click)="clearSelection()"> </i>
                </div>
            </div>
            <div class="d-flex align-items-center gap-4 col-6">
                <div class="col-12 col-md-6 form-group">
                    <input class="form-control picker m-0" [placeholder]="'common.date_picker' | translate" type="text" bsDaterangepicker [(ngModel)]="dateRange" [bsConfig]="datePickerConfig" (bsValueChange)="onDateRangeChange($event)" />
                </div>

                <div class="col-12 col-md-6 form-group">
                    <button class="btn btn-success m-0" (click)="createReport()" type="button" [disabled]="!startDate && !endDate">
                        {{ 'common.report' | translate }}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-3 d-flex justify-content-end">
            <button class="btn" (click)="onExcelExport()">
                <img src="assets/icon/excel.png" />
                <span class="mx-1">{{ 'common.excel_export' | translate }}</span>
            </button>
        </div>
    </div>
    <div class="pivot-wrapper">
        <div *ngIf="showReportPivot" id="pivot" style="height: 100%"></div>
    </div>
</div>
